import styled from 'styled-components';
import AlertTriangleFilled from 'components/icons/alertTriangleFilled';
import SaraAvatar from 'components/icons/saraAvatar';
import Workflow from 'components/icons/workflow';
import { color } from 'theme';

export const ResponderName = styled.span`
    font-size: 1rem;
    font-weight: 200;
    color: ${color('brand.main')};
    letter-spacing: 0.25px;
    display: inline-flex;
    align-items: center;
    padding: 3px 15px 3px 5px;
    border-radius: 20px;
    border: 1px solid ${color('border.divider')};
    gap: 5px;
    flex-shrink: 0;
    height: 2rem;
    cursor: pointer;
    text-decoration: none;
    transition: all 0.2s ease-in-out;

    &:hover {
        background-color: ${color('brand.light')};
        transform: translateY(-1px);
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }

    &:active {
        transform: translateY(0);
    }
`;

export const SmallSaraAvatar = styled(SaraAvatar)`
    width: 1.5rem;
    height: 1.5rem;
`;

export const SmallWorkflowIcon = styled(Workflow)`
    width: 1.5rem;
    height: 1.5rem;
    flex-shrink: 0;
`;

export const NotFoundContent = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
`;

export const StyledWarningIcon = styled(AlertTriangleFilled)`
    width: 1.5rem;
    height: 1.5rem;
    flex-shrink: 0;
    color: #f59e42;
`;
